import React, { useEffect, useState } from 'react';
import { useGetEligibleDrives } from 'src/hooks/offlineDrive.hooks';
import Select, { SingleValue } from 'react-select';
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';
import { useUserContext } from 'src/context/UserProvider';
interface Props {
	isRequired?: boolean;
	selectedDrive?: { label: string; value: string };
	setSelectedDrive: (drive: { label: string; value: string }) => void;
	classNamePrefix?: string;
	className?: string;
	isDisabled?: boolean;
	closeMenuOnSelect?: boolean;
	isAutoSelect?: boolean;
}

const OfflineDriveDropdown = ({
	isRequired,
	selectedDrive,
	setSelectedDrive,
	classNamePrefix = 'my-select-plans',
	isDisabled,
	className,
	closeMenuOnSelect,
	isAutoSelect = true,
}: Props) => {
	const { isDriveAdminLoggedIn } = useUserContext();
	const [searchParams, setSearchParams] = useSearchParams();

	const [options, setOptions] = useState<{ label: string; value: string }[]>([]);

	const { data, isLoading } = useGetEligibleDrives({
		onComplete: data => {
			setOptions(
				data.eligibleDrives.map(drive => ({
					label: drive.driveEndDate && drive?.driveEndDate !== "" && drive?.driveEndDate !== null
						? `${moment(drive.driveDate).format('Do MMM')} - ${moment(drive.driveEndDate).format('Do MMM YYYY')} - ${drive.city}`
						: `${moment(drive.driveDate).format('Do MMM YYYY')} - ${drive.city}`,
					value: drive._id,
				})),
			);
		},
	});

	useEffect(() => {
		if (options.length > 0) {
			// check search params for driveId param
			const driveId = searchParams.get('driveId');
			if (driveId) {
				setSelectedDrive(options.find(option => option.value === driveId) as { label: string; value: string });
			} else if (
				(selectedDrive === null || { label: '', value: '' } || selectedDrive === undefined) &&
				options.length &&
				isAutoSelect
			) {
				setSelectedDrive(options[options.length - 1]);
				setSearchParams({ driveId: options[options.length - 1].value || '' });
			} else {
				setSelectedDrive({ label: '', value: '' });
			}
		}
	}, [options, setSelectedDrive, data, isLoading]);

	return (
		<div>
			<Select
				menuPlacement={'auto'}
				classNamePrefix={classNamePrefix}
				required={isRequired == true ? true : false}
				closeMenuOnSelect={closeMenuOnSelect == false ? false : true}
				value={options.find(option => option.value === selectedDrive?.value)}
				options={options}
				onChange={(value: SingleValue<{ label: string; value: string }>) => {
					if (isDriveAdminLoggedIn) {
						setSearchParams({ driveId: value?.value || '' });
					}
					setSelectedDrive(value as { label: string; value: string });
				}}
				placeholder="Select Drive"
				isDisabled={isDisabled == true ? true : false}
			/>
		</div>
	);
};

export default OfflineDriveDropdown;
